
import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import useInput from "../Assets/UseInput";
import {useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
var serialize = require('serialize-javascript');

function Intervention (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);

    const prevLocation = {
        pathname: '../consequences',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }
    const nextLocation = {
        pathname: '../remark',
        state: { d: d }
    }
    const handleNext = (e) =>{
        e.preventDefault()
        history(nextLocation)
    }

    const {value: Field5701MutName, bind: bindField5701MutName, reset: setField5701MutName} = useInput('')
    const {value: Field5701MutRef, bind: bindField5701MutRef, reset: setField5701MutRef} = useInput('')
    const {value: Field5701ScolaireName, bind: bindField5701ScolaireName, reset: setField5701ScolaireName} = useInput('')
    const {value: Field5701ScolaireRef, bind: bindField5701ScolaireRef, reset: setField5701ScolaireRef} = useInput('')
    const {value: Field5701AccidentTravailName, bind: bindField5701AccidentTravailName, reset: setField5701AccidentTravailName} = useInput('')
    const {value: Field5701AccidentTravailRef, bind: bindField5701AccidentTravailRef, reset: setField5701AccidentTravailRef} = useInput('')
    const {value: Field5701FraisMedicName, bind: bindField5701FraisMedicName, reset: setField5701FraisMedicName} = useInput('')
    const {value: Field5701FraisMedicRef, bind: bindField5701FraisMedicRef, reset: setField5701FraisMedicRef} = useInput('')

    const {value: Field5701HospiName, bind: bindField5701HospiName, reset: setField5701HospiName} = useInput('')
    const {value: Field5701HospiRef, bind: bindField5701HospiRef, reset: setField5701HospiRef} = useInput('')
    const {value: Field5701IndivName, bind: bindField5701IndivName, reset: setField5701IndivName} = useInput('')
    const {value: Field5701IndivRef, bind: bindField5701IndivRef, reset: setField5701IndivRef} = useInput('')
    const {value: Field5701RevGarName, bind: bindField5701RevGarName, reset: setField5701RevGarName} = useInput('')
    const {value: Field5701RevGarRef, bind: bindField5701RevGarRef, reset: setField5701RevGarRef} = useInput('')

    const {value: Field5701DegMatName, bind: bindField5701DegMatName, reset: setField5701DegMatName} = useInput('')
    const {value: Field5701DegMatRef, bind: bindField5701DegMatRef, reset: setField5701DegMatRef} = useInput('')
    const {value: Field5701VoyageName, bind: bindField5701VoyageName, reset: setField5701VoyageName} = useInput('')
    const {value: Field5701VoyageRef, bind: bindField5701VoyageRef, reset: setField5701VoyageRef} = useInput('')
    const {value: Field5701CPASRef, bind: bindField5701CPASRef, reset: setField5701CPASRef} = useInput('')
    const {value: Field5701CPASName, bind: bindField5701CPASName, reset: setField5701CPASName} = useInput('')
    const {value: Field5701AutreName, bind: bindField5701AutreName, reset: setField5701AutreName} = useInput('')
    const {value: Field5701AutreRef, bind: bindField5701AutreRef, reset: setField5701AutreRef} = useInput('')

// radio input custom handleChange
    const [Field57Intervention, setField57Intervention] = useState("");
    const handleChangeField57Intervention = (e) => {
        let value = e.target.value
        setField57Intervention(value);
    }

    const {value: Field59RespCivileAssureurRef, bind: bindField59RespCivileAssureurRef, reset: setField59RespCivileAssureurRef } = useInput('');
    const {value: Field59RespCivileAssureur, bind: bindField59RespCivileAssureur, reset: setField59RespCivileAssureur } = useInput('');
    const {value: Field58Affiliation, bind: bindField58Affiliation, reset: setField58Affiliation } = useInput('');

    // radio input custom handleChange
    const [Field59RespCivile, setField59RespCivile] = useState("");
    const handleChangeField59RespCivile = (e) => {
        let value = e.target.value
        setField59RespCivile(value);
    }

    const {value: Field60ProtectionAssureurRef, bind: bindField60ProtectionAssureurRef, reset: setField60ProtectionAssureurRef } = useInput('');
    const {value: Field60ProtectionAssureur, bind: bindField60ProtectionAssureur, reset: setField60ProtectionAssureur } = useInput('');

    // radio input custom handleChange
    const [Field60Protection, setField60Protection] = useState("");
    const handleChangeField60Protection = (e) => {
        let value = e.target.value
        setField60Protection(value);
    }

    const {value: Field61RCAutoAssureurRef, bind: bindField61RCAutoAssureurRef, reset: setField61RCAutoAssureurRef } = useInput('');
    const {value: Field61RCAutoAssureur, bind: bindField61RCAutoAssureur, reset: setField61RCAutoAssureur } = useInput('');

    // radio input custom handleChange
    const [Field61RCAuto, setField61RCAuto] = useState("");
    const handleChangeField61RCAuto = (e) => {
        let value = e.target.value
        setField61RCAuto(value);
    }

    const [Age, setAge]= useState(localStorage.getItem("Age"))
    const [stored, setStored] =  useState("")

    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            const storedAge = localStorage.getItem('Age')
            setAge(storedAge)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);

            const intervention = JSON.parse(localStorage.getItem('intervention'))

            if (intervention){
                setStored(true)
                setField57Intervention(intervention.Field57Intervention)
                setField5701MutName(intervention.Field5701MutName)
                setField5701MutRef(intervention.Field5701MutRef)
                setField5701AccidentTravailName(intervention.Field5701AccidentTravailName)
                setField5701AccidentTravailRef(intervention.Field5701AccidentTravailRef)
                setField5701ScolaireName(intervention.Field5701ScolaireName)
                setField5701ScolaireRef(intervention.Field5701ScolaireRef)
                setField5701FraisMedicName(intervention.Field5701FraisMedicName)
                setField5701FraisMedicRef(intervention.Field5701FraisMedicRef)
                setField5701HospiName(intervention.Field5701HospiName)
                setField5701HospiRef(intervention.Field5701HospiRef)
                setField5701IndivName(intervention.Field5701IndivName)
                setField5701IndivRef(intervention.Field5701IndivRef)
                setField5701RevGarName(intervention.Field5701RevGarName)
                setField5701RevGarRef(intervention.Field5701RevGarRef)
                setField5701DegMatName(intervention.Field5701DegMatName)
                setField5701DegMatRef(intervention.Field5701DegMatRef)
                setField5701VoyageName(intervention.Field5701VoyageName)
                setField5701VoyageRef(intervention.Field5701VoyageRef)
                setField5701CPASName(intervention.Field5701CPASName)
                setField5701CPASRef(intervention.Field5701CPASRef)
                setField5701AutreName(intervention.Field5701AutreName)
                setField5701AutreRef(intervention.Field5701AutreRef)
                setField59RespCivile(intervention.Field59RespCivile)
                setField60Protection(intervention.Field60Protection)
                setField61RCAuto(intervention.Field61RCAuto)
                setInterventionCheckbox(intervention.InterventionCheckbox)
                setField58Affiliation(intervention.Field58Affiliation)
                setField59RespCivileAssureur(intervention.Field59RespCivileAssureur)
                setField59RespCivileAssureurRef(intervention.Field59RespCivileAssureurRef)
                setField60ProtectionAssureur(intervention.Field60ProtectionAssureur)
                setField60ProtectionAssureurRef(intervention.Field60ProtectionAssureurRef)
                setField61RCAutoAssureur(intervention.Field61RCAutoAssureur)
                setField61RCAutoAssureurRef(intervention.Field61RCAutoAssureurRef)

            }
        };
        fetchData()
    }, []);


    const [InterventionCheckbox, setInterventionCheckbox] = useState({
        field5701Mut : '',
        field5701AccidentTravail : '',
        field5701Scolaire : '',
        field5701FraisMedic : '',
        field5701Hospi : '',
        field5701Indiv : '',
        prefield5701Indiv : '',
        field5701RevGar : '',
        field5701DegMat : '',
        field5701Voyage : '',
        field5701CPAS : '',
        field5701Autre : '',
    });

    const handleChangeCheckbox = (e) => {
        const item = e.target.name;
        const isChecked = e.target.checked;
        let partialChecked = {...InterventionCheckbox}
        partialChecked[item] = isChecked
        setInterventionCheckbox( partialChecked )
      //console.log(InterventionCheckbox)
    }

    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = ""
        //console.log(notValid)
        setNotValid(notValid)
        if (!notValid){
            let intervention = {
                InterventionCheckbox:InterventionCheckbox,
                Field57Intervention:Field57Intervention,
                Field5701MutName:Field5701MutName,
                Field5701MutRef:Field5701MutRef,
                Field5701AccidentTravailName:Field5701AccidentTravailName,
                Field5701AccidentTravailRef:Field5701AccidentTravailRef,
                Field5701ScolaireName:Field5701ScolaireName,
                Field5701ScolaireRef:Field5701ScolaireRef,
                Field5701FraisMedicName:Field5701FraisMedicName,
                Field5701FraisMedicRef:Field5701FraisMedicRef,
                Field5701HospiName:Field5701HospiName,
                Field5701HospiRef:Field5701HospiRef,
                Field5701IndivName:Field5701IndivName,
                Field5701IndivRef:Field5701IndivRef,
                Field5701RevGarName:Field5701RevGarName,
                Field5701RevGarRef:Field5701RevGarRef,
                Field5701DegMatName:Field5701DegMatName,
                Field5701DegMatRef:Field5701DegMatRef,
                Field5701VoyageName:Field5701VoyageName,
                Field5701VoyageRef:Field5701VoyageRef,
                Field5701CPASName:Field5701CPASName,
                Field5701CPASRef:Field5701CPASRef,
                Field5701AutreName:Field5701AutreName,
                Field5701AutreRef:Field5701AutreRef,
                Field59RespCivile:Field59RespCivile,
                Field60Protection:Field60Protection,
                Field61RCAuto:Field61RCAuto,
                Field58Affiliation:Field58Affiliation,
                Field59RespCivileAssureur:Field59RespCivileAssureur,
                Field59RespCivileAssureurRef:Field59RespCivileAssureurRef,
                Field60ProtectionAssureur:Field60ProtectionAssureur,
                Field60ProtectionAssureurRef:Field60ProtectionAssureurRef,
                Field61RCAutoAssureur:Field61RCAutoAssureur,
                Field61RCAutoAssureurRef:Field61RCAutoAssureurRef,

            }
            //let stringName = JSON.stringify(intervention)
            let stringName = serialize(intervention, {isJSON: true});
            localStorage.setItem("intervention" , stringName)
            //console.log(JSON.parse(stringName))
            history(nextLocation)
        }

    }



    const { i18n } = useTranslation();
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
                    {(Age < 16)?
                        <BreadCrumb n={6}/>:<BreadCrumb n={7}/>}
                    <Row>
                        <Col>

                            <h3>{  i18n.t("InterventionTitle") }</h3>

                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form className={"formlevel01"}>
                                <FormGroup check>
                                    <Label for="Field57Intervention" className={(NotValid && Field57Intervention === "") ? "text-danger" : "text"}>{d?  i18n.t('field57InterventionDeath'): i18n.t('field57Intervention')  }   <span className={"text-danger"}>*</span></Label>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field57Intervention"  value="No"  onChange={handleChangeField57Intervention} checked={Field57Intervention === "No"} />
                                            {  i18n.t('NO') }
                                        </Label>
                                    </div>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field57Intervention" value="Yes"  onChange={handleChangeField57Intervention} checked={Field57Intervention === "Yes"} />
                                            {  i18n.t('YES') }
                                        </Label>
                                    </div>

                                </FormGroup>
                                {Field57Intervention === "Yes" &&
                                <div className="formlevel02">
                                    <h4>{i18n.t("Type d’assureur ou organisme")} <span className={"text-danger"}>*</span></h4>
                                    <p>({i18n.t("Cochez et complétez les informations demandées")})</p>
                                    <FormGroup check>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701Mut" onChange={handleChangeCheckbox} value="field5701Mut"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701Mut ? InterventionCheckbox.field5701Mut : '' } />
                                                {  i18n.t("field5701Mut") }
                                            </Label>
                                        </div>
                                        {!!InterventionCheckbox && !!InterventionCheckbox.field5701Mut && InterventionCheckbox.field5701Mut &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701MutName">{ i18n.t("Nom de l’assureur ou organisme")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701MutName} placeholder={ d? i18n.t("placeholderField5701MutNameDeath"):i18n.t("placeholderField5701MutName")} invalid={(NotValid && Field5701MutName === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701MutRef">{i18n.t("Référence / Numéro du dossier")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701MutRef} placeholder={ d? i18n.t("placeholderField5701MutRefDeath"):i18n.t("placeholderField5701MutRef")} invalid={(NotValid && Field5701MutRef === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                        { (Age >= 15) &&
                                        <div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="checkbox" name="field5701AccidentTravail" onChange={handleChangeCheckbox} value="field5701AccidentTravail"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701AccidentTravail ? InterventionCheckbox.field5701AccidentTravail : '' } />
                                                    {  i18n.t("field5701AccidentTravail") }
                                                </Label>
                                            </div>
                                            {!!InterventionCheckbox && !!InterventionCheckbox.field5701AccidentTravail && InterventionCheckbox.field5701AccidentTravail &&
                                            <div className="formlevel02">
                                                <FormGroup >
                                                    <Label for="Field5701AccidentTravailName" invalid={(NotValid && Field5701AccidentTravailName === "")? true : undefined}>{i18n.t("Nom de l’assureur ou organisme")} </Label>
                                                    <Input type="text" maxLength={500}  {...bindField5701AccidentTravailName} placeholder={d? i18n.t("placeholderField5701AccidentTravailNameDeath"):i18n.t("placeholderField5701AccidentTravailName")} invalid={(NotValid && Field5701AccidentTravailName === "")? true : undefined}/>
                                                </FormGroup>
                                                <FormGroup >
                                                    <Label for="Field5701AccidentTravailRef"  invalid={(NotValid && Field5701AccidentTravailRef === "")}>{i18n.t("Référence / Numéro du dossier")} </Label>
                                                    <Input type="text" maxLength={500}  {...bindField5701AccidentTravailRef} placeholder={d? i18n.t("placeholderField5701AccidentTravailRefDeath"):i18n.t("placeholderField5701AccidentTravailRef")} invalid={(NotValid && Field5701AccidentTravailRef === "")? true : undefined}/>

                                                </FormGroup>
                                            </div>
                                            }
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701Scolaire" onChange={handleChangeCheckbox} value="field5701Scolaire"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701Scolaire ? InterventionCheckbox.field5701Scolaire : '' } />
                                                {  i18n.t("field5701Scolaire") }
                                            </Label>
                                        </div>
                                        {!!InterventionCheckbox && !!InterventionCheckbox.field5701Scolaire && InterventionCheckbox.field5701Scolaire &&

                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701ScolaireName">{i18n.t("Nom de l’assureur ou organisme")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701ScolaireName} placeholder={d? i18n.t("placeholderField5701ScolaireNameDeath"):i18n.t("placeholderField5701ScolaireName")} invalid={(NotValid && Field5701ScolaireName === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                            <FormGroup >
                                                <Label for="Field5701ScolaireRef">{i18n.t("Référence / Numéro du dossier")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701ScolaireRef} placeholder={d? i18n.t("placeholderField5701ScolaireRefDeath"):i18n.t("placeholderField5701ScolaireRef")} invalid={(NotValid && Field5701ScolaireRef === "")? true : undefined}/>
                                            </FormGroup>
                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701FraisMedic" onChange={handleChangeCheckbox} value="field5701FraisMedic"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701FraisMedic ? InterventionCheckbox.field5701FraisMedic : '' } />
                                                {  i18n.t("field5701FraisMedic") }
                                            </Label>
                                        </div>
                                        {!!InterventionCheckbox && !!InterventionCheckbox.field5701FraisMedic && InterventionCheckbox.field5701FraisMedic &&

                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701FraisMedicName">{i18n.t("Nom de l’assureur ou organisme")}</Label>
                                                <Input type="text" maxLength={500} {...bindField5701FraisMedicName}
                                                       placeholder={d? i18n.t("placeholderField5701FraisMedicNameDeath"):i18n.t("placeholderField5701FraisMedicName")}/>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701FraisMedicRef">{i18n.t("Référence / Numéro du dossier")}</Label>
                                                <Input type="text" maxLength={500} {...bindField5701FraisMedicRef}
                                                       placeholder={d? i18n.t("placeholderField5701FraisMedicRefDeath"):i18n.t("placeholderField5701FraisMedicRef")} invalid={(NotValid && Field5701FraisMedicRef === "true")}/>
                                            </FormGroup>
                                        </div>
                                        }

                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701Hospi" onChange={handleChangeCheckbox} value="field5701Hospi"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701Hospi ? InterventionCheckbox.field5701Hospi : '' } />
                                                {  i18n.t("field5701Hospi") }
                                            </Label>
                                        </div>
                                        { !!InterventionCheckbox && !!InterventionCheckbox.field5701Hospi && InterventionCheckbox.field5701Hospi &&
                                        <div className="formlevel02">
                                            <FormGroup >
                                                <Label for="Field5701HospiName">{i18n.t("Nom de l’assureur ou organisme")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701HospiName} placeholder={d? i18n.t("placeholderField5701HospiNameDeath"):i18n.t("placeholderField5701HospiName")} invalid={(NotValid && Field5701HospiName === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701HospiRef">{ i18n.t("Référence / Numéro du dossier")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701HospiRef} placeholder={d? i18n.t("placeholderField5701HospiRefDeath"):i18n.t("placeholderField5701HospiRef") } invalid={(NotValid && Field5701HospiRef === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>

                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701Indiv" onChange={handleChangeCheckbox} value="field5701Indiv"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701Indiv ? InterventionCheckbox.field5701Indiv : '' } />
                                                {  i18n.t("field5701Indiv") }
                                            </Label>
                                        </div>
                                        { !!InterventionCheckbox && !!InterventionCheckbox.field5701Indiv && InterventionCheckbox.field5701Indiv &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701IndivName">{i18n.t("Nom de l’assureur ou organisme")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701IndivName} placeholder={d? i18n.t("placeholderField5701IndivNameDeath"):i18n.t("placeholderField5701IndivName")} invalid={(NotValid && Field5701IndivName === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701IndivRef">{i18n.t("Référence / Numéro du dossier")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701IndivRef} placeholder={d? i18n.t("placeholderField5701IndivRefDeath"):i18n.t("placeholderField5701IndivRef")} invalid={(NotValid && Field5701IndivRef === "")? true : undefined}/>

                                            </FormGroup>
                                        </div>

                                        }
                                        
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701RevGar" onChange={handleChangeCheckbox} value="field5701RevGar"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701RevGar ? InterventionCheckbox.field5701RevGar : '' } />
                                                {  i18n.t("field5701RevGar") }
                                            </Label>
                                        </div>
                                        { !!InterventionCheckbox && !!InterventionCheckbox.field5701RevGar && InterventionCheckbox.field5701RevGar &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701RevGarName">{i18n.t("Nom de l’assureur ou organisme")}</Label>
                                                <Input type="text" maxLength={500} {...bindField5701RevGarName}
                                                       placeholder={i18n.t("placeholderField5701RevGarName")}/>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701RevGarRef">{i18n.t("Référence / Numéro du dossier")}</Label>
                                                <Input type="text" maxLength={500} {...bindField5701RevGarRef}
                                                       placeholder={i18n.t("placeholderField5701RevGarRef")} invalid={(NotValid && Field5701RevGarRef === "true")}/>
                                            </FormGroup>
                                        </div>

                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701DegMat" onChange={handleChangeCheckbox} value="field5701DegMat"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701DegMat ? InterventionCheckbox.field5701DegMat : '' } />
                                                {  i18n.t("field5701DegMat") }
                                            </Label>
                                        </div>
                                        { !!InterventionCheckbox && !!InterventionCheckbox.field5701DegMat && InterventionCheckbox.field5701DegMat &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701DegMatName">{d? i18n.t("Nom de l’assureur ou organisme") : i18n.t("FIRSTNAMEDATA")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701DegMatName} placeholder={d?  i18n.t("placeholderField5701DegMatNameDeath") : i18n.t("placeholderField5701DegMatName")} invalid={(NotValid && Field5701DegMatName === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701DegMatRef">{ i18n.t("Référence / Numéro du dossier")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701DegMatRef} placeholder={d? i18n.t("placeholderField5701DegMatRefDeath") : i18n.t("placeholderField5701DegMatRef")} invalid={(NotValid && Field5701DegMatRef === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>

                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701Voyage" onChange={handleChangeCheckbox} value="field5701Voyage"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701Voyage ? InterventionCheckbox.field5701Voyage : '' } />
                                                {  i18n.t("field5701Voyage") }
                                            </Label>
                                        </div>
                                        { !!InterventionCheckbox && !!InterventionCheckbox.field5701Voyage && InterventionCheckbox.field5701Voyage &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701VoyageName">{i18n.t("Nom de l’assureur ou organisme")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701VoyageName} placeholder={d? i18n.t("placeholderField5701VoyageNameDeath"):i18n.t("placeholderField5701VoyageName")} invalid={(NotValid && Field5701VoyageName === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701VoyageRef">{i18n.t("Référence / Numéro du dossier")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701VoyageRef} placeholder={d?i18n.t("placeholderField5701VoyageRefDeath"):i18n.t("placeholderField5701VoyageRef")} invalid={(NotValid && Field5701VoyageRef === "")? true : undefined}/>

                                            </FormGroup>
                                        </div>

                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701CPAS" onChange={handleChangeCheckbox} value="field5701CPAS"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701CPAS ? InterventionCheckbox.field5701CPAS : '' } />
                                                {  i18n.t("field5701CPAS") }
                                            </Label>
                                        </div>
                                        { !!InterventionCheckbox && !!InterventionCheckbox.field5701CPAS && InterventionCheckbox.field5701CPAS &&
                                        <div className="formlevel02">
                                            <FormGroup >
                                                <Label for="Field5701CPASName"  invalid={(NotValid && Field5701CPASName === "")? true : undefined}>{i18n.t("Nom de l’assureur ou organisme")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701CPASName} placeholder={d? i18n.t("placeholderField5701CPASNameDeath"):i18n.t("placeholderField5701CPASName")} invalid={(NotValid && Field5701CPASName === "")? true : undefined}/>

                                            </FormGroup>
                                            <FormGroup >
                                                <Label for="Field5701CPASRef" invalid={(NotValid && Field5701CPASRef === "")}>{i18n.t("Référence / Numéro du dossier")} </Label>
                                                <Input type="text" maxLength={500} {...bindField5701CPASRef} placeholder={d? i18n.t("placeholderField5701CPASRefDeath"):i18n.t("placeholderField5701CPASRef")} invalid={(NotValid && Field5701CPASRef === "")? true : undefined}/>

                                            </FormGroup>
                                        </div>

                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="field5701Autre" onChange={handleChangeCheckbox} value="field5701Autre"  checked={!!InterventionCheckbox && !!InterventionCheckbox.field5701Autre ? InterventionCheckbox.field5701Autre : '' } />
                                                {  i18n.t("field5701Autre") }
                                            </Label>
                                        </div>
                                        { !!InterventionCheckbox && !!InterventionCheckbox.field5701Autre && InterventionCheckbox.field5701Autre &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field5701AutreName">{i18n.t("Nom de l’assureur ou organisme")}</Label>
                                                <Input type="text" maxLength={500} {...bindField5701AutreName}
                                                       placeholder={d? i18n.t("placeholderField5701AutreNameDeath"):i18n.t("placeholderField5701AutreName")}/>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Field5701AutreRef">{i18n.t("Référence / Numéro du dossier")}</Label>
                                                <Input type="text" maxLength={500} {...bindField5701AutreRef}
                                                       placeholder={d? i18n.t("placeholderField5701AutreRefDeath"):i18n.t("placeholderField5701AutreRef")} invalid={(NotValid && Field5701AutreRef === "true")}/>
                                            </FormGroup>
                                        </div>

                                        }
                                    </FormGroup>
                                </div>
                                }
                                <FormGroup>
                                    <Label>{d?i18n.t("field58AffiliationDeath"):i18n.t("field58Affiliation")}</Label>
                                    <Input type="text" maxLength={500} {...bindField58Affiliation}
                                           placeholder={d? i18n.t("placeholderfield58AffiliationDeath"): i18n.t("placeholderfield58Affiliation") }
                                           invalid={(NotValid && Field58Affiliation === "") ? true : undefined}/>
                                    <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                </FormGroup>
                                <FormGroup check>
                                    <Label for="Field59RespCivile" className={(NotValid && Field59RespCivile === "") ? "text-danger" : "text"}>
                                        { d?i18n.t('field59RespCivileDeath'):i18n.t('field59RespCivile') }
                                        </Label>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field59RespCivile"  value="No"  onChange={handleChangeField59RespCivile} checked={Field59RespCivile === "No"} />
                                            {  i18n.t('NO') }
                                        </Label>
                                    </div>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field59RespCivile" value="Yes"  onChange={handleChangeField59RespCivile} checked={Field59RespCivile === "Yes"} />
                                            {  i18n.t('YES') }
                                        </Label>
                                    </div>
                                    {Field59RespCivile === "Yes" &&
                                    <div className="formlevel02">
                                        <FormGroup>
                                            <Label>{i18n.t("Votre assureur")}</Label>
                                            <Input type="text" maxLength={500} {...bindField59RespCivileAssureur}
                                                   placeholder={d? i18n.t("PLACEHOLDERNOMASSUREURDEATH"):i18n.t("PLACEHOLDERNOMASSUREUR")}
                                                   invalid={(NotValid && Field59RespCivileAssureur === "") ? true : undefined}/>
                                            <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{i18n.t("Référence / Numéro du dossier")} </Label>
                                            <Input type="text" maxLength={500} {...bindField59RespCivileAssureurRef}
                                                   placeholder={i18n.t("Référence / Numéro du dossier")}
                                                   invalid={(NotValid && Field59RespCivileAssureurRef === "") ? true : undefined}/>
                                            <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                        </FormGroup>
                                    </div>}
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field59RespCivile" value="Dontknow"  onChange={handleChangeField59RespCivile} checked={Field59RespCivile === "Dontknow"} />
                                            {  i18n.t('Je ne sais pas') }
                                        </Label>
                                    </div>
                                </FormGroup>
                                <FormGroup check>
                                    <Label for="Field60Protection" className={(NotValid && Field60Protection === "") ? "text-danger" : "text"}>
                                        { d?i18n.t('field60ProtectionDeath'):i18n.t('field60Protection') }
                                       </Label>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field60Protection"  value="No"  onChange={handleChangeField60Protection} checked={Field60Protection === "No"} />
                                            {  i18n.t('NO') }
                                        </Label>
                                    </div>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field60Protection" value="Yes"  onChange={handleChangeField60Protection} checked={Field60Protection === "Yes"} />
                                            {  i18n.t('YES') }
                                        </Label>
                                    </div>
                                    {Field60Protection === "Yes" &&
                                    <div className="formlevel02">
                                        <FormGroup>
                                            <Label>{i18n.t("Votre assureur")}</Label>
                                            <Input type="text" maxLength={500} {...bindField60ProtectionAssureur}
                                                   placeholder={d? i18n.t("PLACEHOLDERNOMASSUREURDEATH"):i18n.t("PLACEHOLDERNOMASSUREUR")}
                                                   invalid={(NotValid && Field60ProtectionAssureur === "") ? true : undefined}/>
                                            <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{i18n.t("Référence / Numéro du dossier")}</Label>

                                            <Input type="text" maxLength={500} {...bindField60ProtectionAssureurRef}
                                                   placeholder={i18n.t("Référence / Numéro du dossier")}
                                                   invalid={(NotValid && Field60ProtectionAssureurRef === "") ? true : undefined}/>
                                            <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                        </FormGroup>
                                    </div>}
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field60Protection" value="Dontknow"  onChange={handleChangeField60Protection} checked={Field60Protection === "Dontknow"} />
                                            {  i18n.t('Je ne sais pas') }
                                        </Label>
                                    </div>
                                </FormGroup>
                                <FormGroup check>
                                    <Label for="Field61RCAuto" className={(NotValid && Field61RCAuto === "") ? "text-danger" : "text"}>
                                        { d?i18n.t('field61RCAutoDeath'):i18n.t('field61RCAuto') }
                                       </Label>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field61RCAuto"  value="No"  onChange={handleChangeField61RCAuto} checked={Field61RCAuto === "No"} />
                                            {  i18n.t('NO') }
                                        </Label>
                                    </div>
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field61RCAuto" value="Yes"  onChange={handleChangeField61RCAuto} checked={Field61RCAuto === "Yes"} />
                                            {  i18n.t('YES') }
                                        </Label>
                                    </div>
                                    {Field61RCAuto === "Yes" &&
                                    <div className="formlevel02">
                                        <FormGroup>
                                            <Label>{i18n.t("Votre assureur")}</Label>
                                            <Input type="text" maxLength={500} {...bindField61RCAutoAssureur}
                                                   placeholder={d? i18n.t("PLACEHOLDERNOMASSUREURDEATH"):i18n.t("PLACEHOLDERNOMASSUREUR")}
                                                   invalid={(NotValid && Field61RCAutoAssureur === "") ? true : undefined}/>
                                            <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{i18n.t("Référence / Numéro du dossier")} </Label>

                                            <Input type="text" maxLength={500} {...bindField61RCAutoAssureurRef}
                                                   placeholder={i18n.t("Référence / Numéro du dossier")}
                                                   invalid={(NotValid && Field61RCAutoAssureurRef === "") ? true : undefined}/>
                                            <FormFeedback>{i18n.t('Obligatoire')}</FormFeedback>
                                        </FormGroup>
                                    </div>}
                                    <div className="checkbox">
                                        <Label>
                                            <Input type="radio" name="Field61RCAuto" value="Dontknow"  onChange={handleChangeField61RCAuto} checked={Field61RCAuto === "Dontknow"} />
                                            {  i18n.t("il ne s'agit pas d'un accident de voiture") }
                                        </Label>
                                    </div>
                                </FormGroup>
                                { !stored &&
                                <div className="button-wrapper">
                                    <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }</button>
                                </div>
                                }
                                { stored &&
                                <div className="button-wrapper">
                                    <button id="button" type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }</button>
                                </div>
                                }
                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Intervention

